import i18next from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import { LanguagesEnum } from "globalConstants/languagesEnum";
import { URI } from "settings";

import enUS from "./locales/enUS/common.json";
import esES from "./locales/esES/common.json";
import ptBR from "./locales/ptBR/common.json";

const resources = {
  [LanguagesEnum.americanEnglish]: { translation: enUS },
  [LanguagesEnum.brazilianPortuguese]: { translation: ptBR },
  [LanguagesEnum.spanish]: { translation: esES },
};

const supportedLngs = Object.values(LanguagesEnum);

const basePath = "locales/{{lng}}/{{ns}}.json";

const API_URI = URI.replace("graphql", basePath);

i18next
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: LanguagesEnum.brazilianPortuguese,
    fallbackLng: LanguagesEnum.americanEnglish,
    interpolation: { escapeValue: false },
    defaultNS: "translation",
    ns: ["translation", "api"],
    returnNull: false,
    supportedLngs,
    backend: { backends: [HttpBackend, resourcesToBackend(resources)], backendOptions: [{ loadPath: API_URI }] },
  })
  .then(() => {
    i18next.services.formatter?.add("lowercase", value => value.toLowerCase());
  });

export const apiTranslate = (key: string | string[]): string => i18next.t(key, { ns: ["api", "translation"] });

export default i18next;
